export class Tarea{
	descripcion:string;
	fecha:string;

	constructor(descripcion:string, fecha:string){
		this.descripcion = descripcion;
		this.fecha = fecha;
	}
}